import React, { Component } from 'react';

class Contact extends Component {
    render() {
        return (
            <div>
                 
            </div>
        );
    }
}

export default Contact;